import { LAYOUT } from '@konvoi/shared';
import { useEffect } from 'react';

/**
 * Schließt einen Hinweis nach einer Weile von selbst.
 *
 * ## Wofür, und wofür nicht
 *
 * Nur für Hinweise, die bestätigen, was ohnehin gut ist — „Willkommen zurück,
 * die Standortübertragung läuft wieder" und „Du bist wieder bei der Kolonne".
 * Sie verlangen nichts vom Fahrer. Ihn dafür während der Fahrt tippen zu
 * lassen, heißt, ihn für eine gute Nachricht zu beschäftigen.
 *
 * **Was eine Störung meldet, bleibt stehen.** Wer nicht weiß, dass der
 * Routingdienst schweigt, wartet sonst auf eine Route, die nie kommt. Welcher
 * Hinweis wozu gehört, entscheiden `NAVIGATION_END_SELF_CLEARING` und das Feld
 * `hintSelfClearing` — nicht diese Funktion.
 *
 * Die Schaltfläche bleibt in beiden Fällen daneben: Wer schneller ist, tippt.
 *
 * `schlüssel` bestimmt, wann die Frist neu beginnt. Löst ein Hinweis den
 * anderen ab, bekommt der neue seine eigenen fünf Sekunden — sonst erbte er
 * die Restzeit des vorigen und verschwände, bevor ihn jemand gelesen hat.
 */
export function useSelbstschluss(
  schlüssel: string | null,
  schliessen: () => void,
  frist: number = LAYOUT.selbstschliessendMs,
): void {
  useEffect(() => {
    if (schlüssel === null) {
      return;
    }
    const uhr = setTimeout(schliessen, frist);
    return () => {
      clearTimeout(uhr);
    };
    // `schliessen` ist bewusst nicht in der Liste: Die Funktion entsteht bei
    // jedem Durchlauf neu, und die Frist begänne dann bei jeder Neuzeichnung
    // von vorn — bei einer Karte, die im Sekundentakt neu zeichnet, liefe sie
    // nie ab. Maßgeblich ist allein, welcher Hinweis dasteht.
  }, [schlüssel, frist]);
}
